import type { RouteObject } from "react-router-dom";

export const slackMessagingRoutes: RouteObject[] = [
  {
    handle: { breadcrumb: "Dashboard" },
    async lazy() {
      const { Page } = await import("../app/page");
      return { element: <Page /> };
    },
    children: [
      {
        index: true,
        async lazy() {
          const { SlackMessagingDashboard } = await import(
            "./slack-messaging-dashboard"
          );
          return { Component: SlackMessagingDashboard };
        },
      },
      {
        path: "send",
        handle: { breadcrumb: "Send Message" },
        async lazy() {
          const { SlackMessagingPage } = await import("./slack-messaging");
          return { Component: SlackMessagingPage };
        },
      },
      {
        path: "delete",
        handle: { breadcrumb: "Delete Message" },
        async lazy() {
          const { SlackMessagingDeletePage } = await import(
            "./slack-messaging-delete"
          );
          return { Component: SlackMessagingDeletePage };
        },
      },
    ],
  },
];
